<template>
  <div class="row green-fitout__entry">
    <div class="small-12">
      <div
        v-if="isTenant && !isStarted"
        class="tenant-not-start hint"
      >
        {{ $t('tenantProjects.greenFitOut.tenantStatHint') }}
      </div>
      <GreenFitOutActionBtns />
    </div>

    <template
      v-if="isStarted"
    >
      <div class="small-6">
        <div class="green-fitout__left">
          <GreenFitOutFolders />
          <GreenFitOutRemarks />
        </div>
      </div>
      <div class="small-6">
        <div class="green-fitout__right">
          <GreenFitOutSubTabs />
        </div>
      </div>
    </template>
    <div
      v-else
      class="small-12"
    >
      <GreenFitOutGuideline />
    </div>
  </div>
</template>

<script>
import GreenFitOutGuideline from './GreenFitOutGuideline.vue'
import GreenFitOutActionBtns from './GreenFitOutActionBtns.vue'
import { useStoreGetters } from '@/store'
import GreenFitOutFolders from './GreenFitOutFolders.vue'
import GreenFitOutSubTabs from './GreenFitOutSubTabs.vue'
import GreenFitOutRemarks from './GreenFitOutRemarks.vue'
import { useCurrentGreenFitoutStatus } from './hook'

export default {
  components: {
    GreenFitOutFolders,
    GreenFitOutGuideline,
    GreenFitOutSubTabs,
    GreenFitOutActionBtns,
    GreenFitOutRemarks,
  },
  setup () {
    const userStore = useStoreGetters('user', ['isTenant'])
    const { isStarted } = useCurrentGreenFitoutStatus()

    return {
      ...userStore,
      isStarted,
    }
  },
}
</script>

<style lang="scss" scoped>

.tenant-not-start {
  padding-left: 15px;
  padding-bottom: 20px;
  font-style: italic;

}
.green-fitout__entry {
  .green-fitout {
    &__left {
      margin-right: 10px;
    }
    &__right {
      margin-left: 10px;
    }
  }
}
</style>
